const locale = {
	APPLICATIONS: 'Programlar',
	DASHBOARDS: 'Kontrol Paneli',
	CALENDAR: 'Takvim',
	ECOMMERCE: 'E-Ticaret',
	ACADEMY: 'Akademi',
	MAIL: 'Posta',
	TASKS: 'Yapılacaklar',
	FILE_MANAGER: 'Dosya Yöneticisi',
	CONTACTS: 'Kişiler',
	MESSENGER: 'Sohbet',
	SCRUMBOARD: 'Proje',
	NOTES: 'Notlar'
};

export default locale;
